import { createContext } from 'react';
import { CardArt, TributeArt } from './generated/CardArt';

// Which art tier card views resolve against. 'web' is the bundled tier;
// 'print' is the 600 dpi tier served from /print-art (gitignored, generated
// by scripts/process_card_assets.ts --print-tier on machines with the
// "Mythos Sync" sources).
export type ArtResolution = 'web' | 'print';

export const ArtResolutionContext = createContext<ArtResolution>('web');

export function cardArtUrl(
  slug: string,
  resolution: ArtResolution,
): string | undefined {
  if (resolution === 'print') {
    return `/print-art/${slug}.webp`;
  }
  return CardArt[slug as keyof typeof CardArt];
}

export function tributeArtUrl(
  slug: string,
  resolution: ArtResolution,
): string | undefined {
  if (resolution === 'print') {
    return `/print-art/${slug}.webp`;
  }
  return TributeArt[slug as keyof typeof TributeArt];
}
